import Vue from 'vue'

import axios from 'axios'

import moment from 'moment'
Vue.prototype.moment = moment

// import router from '@/router'
import store from '@/store'

import BootstrapVue from 'bootstrap-vue'
Vue.use(BootstrapVue)

const vm = new Vue()

axios.defaults.withCredentials = true
axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest'
axios.defaults.headers.common['Accept'] = 'application/json'
axios.defaults.headers.post['Content-Type'] = 'application/json'
// Laravel sets an encrypted XSRF-TOKEN cookie; axios sends it as X-XSRF-TOKEN on mutating requests.
axios.defaults.xsrfCookieName = 'XSRF-TOKEN'
axios.defaults.xsrfHeaderName = 'X-XSRF-TOKEN'

axios.interceptors.request.use(
    (request) => {
        return request
    }
)

axios.interceptors.response.use(
    (response) => {
        return response
    },
    (error) => {
        let response = null
        let status = null
        let message = null

        if (error.response) {
            status = error.response.status

            if (error.response.data) {
                message = error.response.data.message
            }
        }

        // if (
        //     status &&
        //     status == 401 &&
        //     router.history.current &&
        //     router.history.current.name !== 'Login'
        // ) {
        //     vm.$bvToast.toast('Please re-login.', {
        //         title: 'Session Expired',
        //         variant: 'danger',
        //         solid: false,
        //         autoHideDelay: 5000,
        //         appendToast: false
        //     })
        // }

        if (
            status &&
            (status == 422 || status == 500)
        ) {
            const h = vm.$createElement

            const content = h(
                'p',
                {
                    class: ['', 'mb-0']
                },
                [
                    h('div', { class: 'mb-0' }, message),
                ]
            )

            vm.$bvToast.toast([content], {
                title: 'Internal Server Error',
                variant: 'danger',
                solid: false,
                autoHideDelay: 5000,
                appendToast: true
            })

            if (
                error.response &&
                error.response.data
            ) {
                response = {
                    data: {
                        message: error.response.data.message,
                        errors: error.response.data.errors
                    },
                    status: error.response.status,
                    config: {
                        url: error.response.config.url
                    },
                    time: moment().toISOString()
                }

                store.commit('addError', response)
            }
        }

        return Promise.reject(error)
    }
);

export default axios
